import { z } from 'zod';

/** Eventi tracciati nel `file_log` append-only. */

export const EventoFile = z.enum([
  'Caricato',
  'Sostituito',
  'Cancellato',
  'Scaricato',
  'Rinominato',
]);
export type EventoFile = z.infer<typeof EventoFile>;
